import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card } from './ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { HelpCircle, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { faqData } from '../data/mock';

const FAQ = () => {
  // FAQ Schema for SEO
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section className="py-20 bg-slate-50" id="faq">
      {/* FAQ Schema */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <div className="container mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-12">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider">Got Questions?</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Everything you need to know about the course
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto mb-12">
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`faq-${index}`}
                className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:border-emerald-300 transition-colors duration-300 px-6"
              >
                <AccordionTrigger className="py-5 hover:no-underline text-left">
                  <div className="flex items-center gap-3">
                    <HelpCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                    <span className="font-semibold text-slate-900">{faq.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-slate-600 ml-8">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Still have questions */}
        <Card className="max-w-xl mx-auto p-6 text-center bg-white border-slate-200">
          <MessageCircle className="w-10 h-10 text-emerald-500 mx-auto mb-3" />
          <h3 className="text-lg font-semibold text-slate-900 mb-2">Still have questions?</h3>
          <p className="text-slate-600 text-sm mb-4">
            Our team is here to help you succeed
          </p>
          <Button className="bg-emerald-500 hover:bg-emerald-600 text-white">
            Contact Support
          </Button>
        </Card>
      </div>
    </section>
  );
};

export default FAQ;
